import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Application',
    column_type: 'id',
    label_key_path: 'application.id',
  },
  created_at: {
    model_name: 'Application',
    column_type: 'datetime',
    label_key_path: 'application.createdAt',
  },
  updated_at: {
    model_name: 'Application',
    column_type: 'datetime',
    label_key_path: 'application.updatedAt',
  },
  name: {
    model_name: 'Application',
    column_type: 'string',
    label_key_path: 'application.name',
  },
  desc: {
    model_name: 'Application',
    column_type: 'string',
    label_key_path: 'application.desc',
  },
  share_desc: {
    model_name: 'Application',
    column_type: 'string',
    label_key_path: 'application.shareDesc',
  },
  share_title: {
    model_name: 'Application',
    column_type: 'string',
    label_key_path: 'application.shareTitle',
  },
  wechat_application: {
    model_name: 'Application',
    column_type: 'belongs_to',
    label_key_path: 'application.wechatApplication',
    extra: {
      association_name: 'wechat_application',
      model_name: 'BsWechatMiniProgram::Application',
      foreign_key: 'wechat_application_id',
      display_column: 'id',
    },
  },
  wechat_application_id: {
    model_name: 'Application',
    column_type: 'belongs_to',
    label_key_path: 'application.wechatApplication',
    extra: {
      association_name: 'wechat_application',
      model_name: 'BsWechatMiniProgram::Application',
      foreign_key: 'wechat_application_id',
      display_column: 'id',
    },
  },
  application_admin_users_role_id: {
    model_name: 'Application',
    column_type: 'string',
    label_key_path: 'application.applicationAdminUsersRoleId',
  },
  share_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 20,
    },
    label_key_path: 'application.shareImage',
  },
  share_image_with_audio: {
    model_name: 'Application',
    prop: 'share_image_attachment',
    label_key_path: 'application.shareImageAttachment',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 20,
    },
  },
  logo: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 20,
    },
    label_key_path: 'application.logo',
  },
  logo_with_audio: {
    model_name: 'Application',
    prop: 'logo_attachment',
    label_key_path: 'application.logoAttachment',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 20,
    },
  },
  creator: {
    model_name: 'Application',
    column_type: 'belongs_to',
    label_key_path: 'application.creator',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUser',
      foreign_key: 'creator_id',
      display_column: 'name',
    },
  },
  creator_id: {
    model_name: 'Application',
    column_type: 'belongs_to',
    label_key_path: 'application.creator',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUser',
      foreign_key: 'creator_id',
      display_column: 'name',
    },
  },
  poster_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 20,
    },
    label_key_path: 'application.posterImage',
  },
  poster_image_with_audio: {
    model_name: 'Application',
    prop: 'poster_image_attachment',
    label_key_path: 'application.posterImageAttachment',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 20,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
